
export enum TemplateFiltroPadrao{
  Default = 1,
  Polo = 2,
  PEC = 3,
  HomePEC = 4
}
